import { colors } from '../../colors'

interface DateFormatterProps {
  dateString: string
  format?: 'full' | 'date-only' | 'time-only' | 'japanese-date'
  style?: React.CSSProperties
}

const DateFormatter: React.FC<DateFormatterProps> = ({
  dateString,
  format = 'full',
  style = {},
}) => {
  const formatDate = (dateString: string, format: string) => {
    const date = new Date(dateString)

    switch (format) {
      case 'full':
        return (
          date.toLocaleDateString('ja-JP', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }) +
          ' ' +
          date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })
        )
      case 'date-only':
        return date.toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      case 'time-only':
        return date.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })
      case 'japanese-date':
        return date.toLocaleDateString('ja-JP', {
          month: 'long',
          day: 'numeric',
        })
      default:
        return dateString
    }
  }

  const defaultStyles: React.CSSProperties = {
    color: colors['text-secondary'],
    fontSize: '12px',
    ...style,
  }

  return <span style={defaultStyles}>{formatDate(dateString, format)}</span>
}

export default DateFormatter
